import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;
import './HistoriquePrixModal.css';

const HistoriquePrixModal = ({ isOpen, onClose, produitId = null, fournisseurId = null, title = "Historique des prix proposé" }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            fetchHistory();
        }
    }, [isOpen, produitId, fournisseurId]);

    const fetchHistory = async () => {
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('token');
            const params = {};
            if (produitId) params.produitId = produitId;
            if (fournisseurId) params.fournisseurId = fournisseurId;

            const res = await axios.get(`${API_URL}/demandes-prix-fournisseurs/historique-prix`, {
                headers: { Authorization: `Bearer ${token}` },
                params
            });

            setHistory(res.data || []);
        } catch (err) {
            console.error('Erreur historique prix:', err);
            setError('Erreur lors du chargement de l\'historique des prix.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-backdrop">
            <div className="historique-prix-modal">
                <div className="historique-header">
                    <h3>
                        <i className="fas fa-chart-line" style={{ marginRight: '10px', color: '#10b981' }}></i>
                        {title}
                    </h3>
                    <button className="close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="historique-body">
                    {loading ? (
                        <div className="historique-loading">
                            <i className="fas fa-spinner fa-spin"></i> Chargement de l'historique...
                        </div>
                    ) : error ? (
                        <div className="dp-alert dp-alert-error">{error}</div>
                    ) : history.length === 0 ? (
                        <div className="historique-empty">
                            <i className="fas fa-search" style={{ fontSize: '2rem', color: '#cbd5e1', marginBottom: '10px' }}></i>
                            <p>Aucun historique de prix disponible pour ce critère.</p>
                        </div>
                    ) : (
                        <div className="historique-table-container">
                            <table className="historique-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Réf Demande</th>
                                        <th>Fournisseur</th>
                                        <th>Produit</th>
                                        <th>Version</th>
                                        <th>Prix Unitaire HT</th>
                                        <th>Remises</th>
                                        <th>Prix Net HT</th>
                                        <th>TVA</th>
                                        <th>Prix TTC</th>
                                        <th>Délai / Dispo</th>
                                        <th>Devis PDF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((item, index) => {
                                        const dateStr = item.dateReponse ? new Date(item.dateReponse).toLocaleDateString('fr-FR') : 'N/A';
                                        const fournNom = item.fournisseur ? (item.fournisseur.nom || item.fournisseur.raisonSociale) : 'N/A';
                                        const prodNom = item.produit ? item.produit.nomProduit : 'N/A';
                                        const prodRef = item.produit ? item.produit.reference : 'N/A';

                                        return (
                                            <tr key={index} className={item.isLatestVersion ? 'latest-version-row' : ''}>
                                                <td>{dateStr}</td>
                                                <td><code>{item.demandeRef}</code></td>
                                                <td><strong>{fournNom}</strong></td>
                                                <td>
                                                    <div><strong>{prodNom}</strong></div>
                                                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{prodRef}</div>
                                                </td>
                                                <td>
                                                    <span className={`version-tag ${item.isLatestVersion ? 'latest' : ''}`}>
                                                        v{item.versionNumber} {item.isLatestVersion ? '(Actuel)' : ''}
                                                    </span>
                                                </td>
                                                <td>{Number(item.prixUnitaireHT || 0).toFixed(3)} DT</td>
                                                <td>
                                                    {item.remisePercentage || 0}%
                                                    {item.remisePercentage2 > 0 ? ` + ${item.remisePercentage2}%` : ''}
                                                </td>
                                                <td><strong>{Number(item.prixNetHT || 0).toFixed(3)} DT</strong></td>
                                                <td>{item.tvaPercentage || 19}%</td>
                                                <td style={{ color: '#059669', fontWeight: 600 }}>{Number(item.prixTTC || 0).toFixed(3)} DT</td>
                                                <td>
                                                    <div style={{ fontSize: '0.8rem' }}>{item.delaiProduit || '-'}</div>
                                                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{item.disponibiliteProduit || ''}</div>
                                                </td>
                                                <td>
                                                    {item.pieceJointeDevis ? (
                                                        <a
                                                            href={`${API_URL.replace('/api', '')}${item.pieceJointeDevis}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="devis-link"
                                                        >
                                                            <i className="fas fa-file-pdf"></i> Devis
                                                        </a>
                                                    ) : (
                                                        <span style={{ color: '#94a3b8' }}>-</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className="historique-footer">
                    <button className="btn-cancel" onClick={onClose}>Fermer</button>
                </div>
            </div>
        </div>
    );
};

export default HistoriquePrixModal;
